/**
 * @fileoverview DELETE handler for the "/apps/:app_id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appsAppIdCacheKeys } from "./constants";
import type { DeleteAppsAppIdProps, AppsAppIdResult, AppSettingCommandErrors } from "./types";

export const deleteAppsAppId = reactQueryMutationAdapter(
  appsAppIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<AppSettingCommandErrors>()(
    (props: DeleteAppsAppIdProps): Promise<AppsAppIdResult> => {
      return fetch(`/apps/${props.appId}`, "DELETE", props, {}, { propagateFetchRequestError: false });
    }
  )
);
